import httpClient from "@plugins/http";

const fetchMeetingLink = (params) => {
  return httpClient.get(`/apis/meeting-link`, {
    params: params,
  });
};

const fetchAllAssignmentMeetingLinks = (assignmentUuid) => {
  return httpClient.get(`/apis/meeting-link/assignment/${assignmentUuid}`);
};

const fetchAssignmentMeetingLinksStatus = (assignmentUuid) => {
  return httpClient.get(`/apis/meeting-link/assignment/${assignmentUuid}/status`);
};

const fetchTeamMeetingLinks = ({ activityId, assignmentUuid }) => {
  return httpClient.get(`/apis/meeting-link/activity-team/${activityId}`, {
    params: {
      assignmentUuid: assignmentUuid,
    },
  });
};

export default {
  fetchMeetingLink,
  fetchAllAssignmentMeetingLinks,
  fetchAssignmentMeetingLinksStatus,
  fetchTeamMeetingLinks,
};
